import { alternatingRow } from './shared';
/**
 * Styles override for the Fluent `DetailsList` component.
 */
export const detailsListStyles = theme => {
    return {
        root: {
            selectors: {
                '.ms-List-cell .ms-DetailsRow:not(:hover)': {
                    background: alternatingRow(theme).odd,
                },
                '.ms-List-cell:nth-child(even) .ms-DetailsRow:not(:hover)': {
                    background: alternatingRow(theme).even,
                },
            },
        },
    };
};
/**
 * Styles override for the Fluent `DetailsRow` component's "rows".
 */
export const detailsListRowStyles = theme => {
    var _a;
    return ({
        root: {
            // borderBottom:
            //   '0.1em solid ' + setColorAlpha(theme?.semanticColors.menuDivider, '0.80'),
            selectors: {
                ':hover': {
                    boxShadow: (_a = theme === null || theme === void 0 ? void 0 : theme.effects) === null || _a === void 0 ? void 0 : _a.elevation4,
                },
            },
        },
    });
};
/**
 * Style override for the Fluent `DetailsList` component's group headings.
 */
export const groupHeaderStyles = theme => {
    var _a, _b;
    return ({
        root: {
            borderWidth: '0.2em',
            borderStyle: 'outset',
            borderColor: ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.neutralLighter) + ' ' + ((_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.themeSecondary),
            borderBottomWidth: 0,
            transition: 'borderColor 0.5s ease',
        },
        title: {
            paddingLeft: 0,
            overflow: 'inherit',
        },
    });
};
/**
 * Style override for the Fluent `DetailsList` groups.
 */
export const groupedListStyles = theme => {
    var _a, _b;
    return ({
        group: {
            boxShadow: (_a = theme === null || theme === void 0 ? void 0 : theme.effects) === null || _a === void 0 ? void 0 : _a.elevation8,
            borderRadius: (_b = theme === null || theme === void 0 ? void 0 : theme.effects) === null || _b === void 0 ? void 0 : _b.roundedCorner2,
        },
    });
};
